import PropTypes from 'prop-types'
import { Dialog } from '@progress/kendo-react-dialogs'
import { useEffect, useState } from 'react'

import { Lookup, prefix } from '~/utils'
import { Loading } from '~/components'
import { ServiceRequestAPI, ExecutionAPI } from '~/api'

import AttachmentTaskChecklistGrid from './attachment-task-checklist.grid'

import SC from '../styled.activity'
import { insertLog } from '../../../../../utils'

const AttachmentTaskActivityChecklistModal = ({
  task,
  activity,
  location,
  toggleModal,
  setShowAlert,
  attachmentList,
  setActivityList,
  setAttachmentList,
}) => {
  const [fileSize, setFileSize] = useState(20)
  const [fileType, setFileType] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const modalTitle = (() => task.inEdit ? 'Edit Documents' : 'View Documents')()

  const _handleDeleteAttachment = (data) => {
    const mappedDataGrid = attachmentList
      .filter(item => !(item.id === data.id && item.is_new))
      .map(item =>
        item.id === data.id && !item.is_new
          ? { ...item, is_deleted: true }
          : item
      )
    setActivityList((prev) => {
      return prev?.map((act) => {
        if (act.id === activity.id) {
          const progress_task_header_list = act.progress_task_header_list?.map((header) => {
            const progress_task_attachment_list = header.progress_task_attachment_list?.map((attachment) => {
              if (attachment.id === data.id) {
                return { ...attachment, is_deleted: true }
              }
              return attachment
            })
            if (header.id === task.id) {
              return {
                ...header,
                progress_task_attachment_list,
              }
            }
            return header
          })
          return {
            ...act,
            progress_task_header_list
          }
        }
        return act
      })
    })
    setAttachmentList(mappedDataGrid)
  }

  const _handleInsertAttachment = (payload) => {
    console.log('🚀 ~ const_handleInsertAttachment:', payload)
    const mappedDataGrid = attachmentList ? [...attachmentList, ...payload] : payload
    setAttachmentList(mappedDataGrid)
  }

  const _getFileSize = async () => {
    try {
      const filter =
        '[{"field":"type","type":"text","value":"File_Size"},{"field":"is_active","type":"bool","value":"true"}]'
      const response = await ServiceRequestAPI.GetAllFromTableEnum(0, 100, filter)

      setFileSize(parseInt(response.data[0].Value))
      return response
    } catch (error) {
      return error
    }
  }

  const _getFileType = async () => {
    try {
      let parsedData = []
      const filterDocument =
        '[{"field":"type","type":"text","value":"File_Document"},{"field":"is_active","type":"bool","value":"true"}]'
      const response = await ServiceRequestAPI.GetAllFromTableEnum(0, 100, filterDocument)

      if (response.data.length) {
        parsedData.push(response.data[0].Value)
      }

      const filterImage =
        '[{"field":"type","type":"text","value":"File_Image"},{"field":"is_active","type":"bool","value":"true"}]'
      const imageEnum = await ServiceRequestAPI.GetAllFromTableEnum(0, 100, filterImage)
      if (imageEnum.data.length) {
        parsedData.push(imageEnum.data[0].Value)
      }
      parsedData = parsedData.join('|')
      parsedData = parsedData.split('|').join(', .')
      setFileType('.' + parsedData)

      return response
    } catch (error) {
      return error
    }
  }

  const _getAll = async () => {
    setIsLoading(true)
    await Promise.all([_getFileSize(), _getFileType()])
    setIsLoading(false)
  }

  useEffect(() => {
    if (task.inEdit) {
      _getAll()
    }
  }, [task.inEdit])

  const _handleFileUpload = async (e) => {
    const files = e.target.files
    const fileSizeLimit = fileSize * 1024 * 1024
    let isLimitExceeded = false
    // let isFileTypeValid = true

    // Check if files has correct file extention type
    for (let i = 0; i < files.length; i++) {
      const v = files[i]
      const fileExtension = v.name.split('.').pop().toLowerCase()
      // Check for valid file type
      if (!fileType.includes(fileExtension)) {
        // isFileTypeValid = false
        insertLog({
          message: 'Invalid file type uploaded',
          action: Lookup.LOG_ACTION.UPLOAD,
          refNo:  task.sr_code,
          module: Lookup.LOG_MODULE.EXECUTION,
          submodule: Lookup.LOG_SUB_MODULE.DOCUMENT,
        })
        setShowAlert({
          msg: `You can only upload files with the following extensions: ${fileType}`,
          type: 'error',
          visible: true,
          success: false,
        })
        break
      }
      // Check if file size exceeds the limit
      if (v.size > fileSizeLimit) {
        isLimitExceeded = true
      }
    }

    if (isLimitExceeded) {
      insertLog({
        message: 'File size exceeds the limit',
        action: Lookup.LOG_ACTION.UPLOAD,
        refNo:  task.sr_code,
        module: Lookup.LOG_MODULE.EXECUTION,
        submodule: Lookup.LOG_SUB_MODULE.DOCUMENT,
      })
      setShowAlert({
        msg: `One of the file size exceeds ${fileSize} MB`,
        type: 'error',
        success: false,
        visible: true,
      })
    } else {
      const payload = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]

        payload.push({
          id: new Date().getTime(),
          file: file,
          is_new: true,
          filesize: file.size,
          filename: file.name,
          created_by: '-'
        })
      }

      _handleInsertAttachment(payload)
    }
  }

  const _handleDownloadAttachment = async (props) => {
    try {
      let response = null

      // Extract filename from doc.path (after last '/')
      let filenameFromPath = props.path
      if (typeof filenameFromPath === 'string' && filenameFromPath.includes('/')) {
        filenameFromPath = filenameFromPath.substring(filenameFromPath.lastIndexOf('/') + 1)
      }

      if (props.path.toLowerCase().includes('lbs-attachment')) {
        response = await ServiceRequestAPI.GetAttachmentFileSR(filenameFromPath)
      } else {
        response = await ExecutionAPI.GetAttachmentFile(filenameFromPath)
      }
      const baseFile64 = response.data
      const prefixBase64 = prefix(props.filename)
      const dataBase64 = prefixBase64 + baseFile64

      const a = document.createElement('a')
      a.href = dataBase64
      a.download = props.filename
      document.body.appendChild(a)
      a.click() // <-- This triggers the download
      document.body.removeChild(a) // <-- Clean up
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <Dialog onClose={() => toggleModal(task.inEdit ? 'edit' : 'view', null, null)}>
      <SC.ModalTaskAttachmentContainer>
        <SC.ModalTaskChecklistHeaderContainer>
          <SC.TaskChecklistHeaderTitle>
            {modalTitle} - {activity.activity_name} - {task.task}
          </SC.TaskChecklistHeaderTitle>
          <div id='close-modal'>
            <SC.CloseIcon
              style={{ color: 'white' }}
              onClick={() => {
                toggleModal(task.inEdit ? 'edit' : 'view', null, null)
              }}
            />
          </div>
        </SC.ModalTaskChecklistHeaderContainer>
        {isLoading && (
          <SC.LoadingContainer>
            <Loading id='exe-doc_mdl-loading-indicator' />
          </SC.LoadingContainer>
        )}

        {!isLoading && task.inEdit && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SC.DocumentUploadButtonContainer>
              <form id='sr-doc_mdl-upload-form' style={{ margin: 'auto' }}>
                <SC.UploadButton id='sr-doc_mdl-upload-btn' htmlFor='sr-doc_mdl-upload-input-file'>
                  Upload File
                </SC.UploadButton>
                <input
                  id='sr-doc_mdl-upload-input-file'
                  multiple
                  type='file'
                  name='sr-docs-attacments'
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    _handleFileUpload(e)
                    e.target.value = null
                  }}
                  accept={fileType}
                />
              </form>
            </SC.DocumentUploadButtonContainer>
          </div>
        )}

        {!isLoading && (
          <AttachmentTaskChecklistGrid
            inEdit={task.inEdit}
            dataGrid={attachmentList ? attachmentList.filter((item) => !item.is_deleted) : []}
            location={location}
            onDownload={_handleDownloadAttachment}
            onDelete={_handleDeleteAttachment}
          />
        )}

      </SC.ModalTaskAttachmentContainer>
    </Dialog>
  )
}

AttachmentTaskActivityChecklistModal.propTypes = {
  task: PropTypes.object,
  activity: PropTypes.object,
  location: PropTypes.object,
  toggleModal: PropTypes.func,
  setShowAlert: PropTypes.func,
  attachmentList: PropTypes.array,
  setAttachmentList: PropTypes.func,
}

export default AttachmentTaskActivityChecklistModal
